// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type DeleteDashboardModalType from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const RLLAsyncDeleteDashboardModal = lazyForPaint(
	() => import(/* webpackChunkName: "async-delete-dashboard-modal" */ './index'),
	{ ssr: false },
);

const RLLAsyncDeleteDashboardModalContainer = (
	props: JSX.LibraryManagedAttributes<
		typeof DeleteDashboardModalType,
		ComponentProps<typeof DeleteDashboardModalType>
	>,
): React.JSX.Element => (
	<Placeholder name="delete-dashboard-modal" fallback={<></>}>
		<RLLAsyncDeleteDashboardModal {...props} />
	</Placeholder>
);

export default RLLAsyncDeleteDashboardModalContainer;
